// getIcon returns inline svg markup when the backend icon was inlined on the
// server - consumers that need an image url (img src, map markers) get it as
// a data url instead of fetching the backend file (blocked via CORS)
export const iconToImageSrc = (icon: string): string =>
  icon.trimStart().startsWith("<svg")
    ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(icon)}`
    : icon;
